import { Button } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentContainer, StyledTypography } from '../importExport/ui';

export type UploadContentProps = {
    onDownloadClick: () => void;
};

const UploadContent = ({ onDownloadClick }: UploadContentProps) => {
    const { t } = useTranslation('importExportExcel');

    const handleDownloadTemplate = useCallback(
        e => {
            e.preventDefault();
            onDownloadClick();
        },
        [onDownloadClick]
    );

    return (
        <ContentContainer direction="vertical">
            <StyledTypography>{t('importExportExcel:description.message')}</StyledTypography>
            <StyledTypography>{t('importExportExcel:description.note')}</StyledTypography>
            <ContentContainer direction="horizontal">
                <Button onClick={handleDownloadTemplate} type="link">
                    {t('importExportExcel:description.downloadTemplate')}
                </Button>
            </ContentContainer>
        </ContentContainer>
    );
};

export default UploadContent;
